const IMAGE_FORMATS = ["jpeg", "jpg", "png", "gif", "bmp", "webp", "tiff", "svg"];

/**
 * Normalise le contenu fichier d'un message pour toujours retourner un tableau.
 * Retrocompatible avec les anciens messages (objet unique).
 */
export function normalizeFileContenu(contenu) {
  if (Array.isArray(contenu)) return contenu;
  if (contenu && typeof contenu === "object" && contenu.fileUrl !== undefined)
    return [contenu];
  return [];
}

export function isImageFormat(format) {
  return IMAGE_FORMATS.includes(format?.toLowerCase());
}
